import enquireApi from '../../api/enquiry.api'
const state = {
	allJsonData: []
}
const mutations = {
	setEnquiryState(state, data) {
		for (let key in data) {
			if (data.hasOwnProperty(key)) {
				state[key] = data[key]
			}
		}
	}
}
const getters = {
	filterJsonData: state => filterType => {
		let filterData = []
		state.allJsonData.forEach(item => {
			if (filterType === 'hours') {
				let data = item[filterType] || item['reportTime'].split(' ')[0]
				filterData.push(data)
			} else {
				filterData.push(item[filterType])
			}
		})

		return filterData
	}
}
const actions = {
	// 获取询盘
	getTodayEnquiry() {
		return enquireApi.getTodayEnquiry()
	},

	getEnquiryByDate(context, params) {
		return enquireApi.getEnquiryByDate(params)
	}
}

export default {
	state, mutations, getters, actions,
	namespaced: true
}
